<template>
  <div>
    <v-layout wrap justify-end>
      <v-flex xs4 sm4 md4 lg4 xl4>
        <v-menu offset-y left>
          <template v-slot:activator="{ attrs, on }">
            <v-layout
              style="cursor: pointer"
              wrap
              justify-center
              v-bind="attrs"
              v-on="on"
            >
              <v-flex xs12>
                <v-icon color="#FF0000" size="25">
                  mdi-account-circle-outline
                </v-icon>
              </v-flex>
              <v-flex xs12 style="line-height: 0.5" pt-1>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 12px;
                    color: #ff0000;
                  "
                >
                  Account
                </span>
              </v-flex>
            </v-layout>
          </template>
          <v-card tile flat :elevation="0" max-width="250px">
            <v-layout wrap justify-center>
              <v-flex pt-4 xs12>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  Welcome
                </span>
              </v-flex>
              <v-flex xs12>
                <span
                  v-if="!appLogin"
                  style="
                    font-family: poppinsmedium;
                    font-size: 13px;
                    color: #1e1b1b;
                  "
                >
                  Sign up as customer
                </span>
              </v-flex>
              <v-flex pt-2 xs12>
                <v-icon color="#CCB4B4" size="30">
                  mdi-account-circle-outline
                </v-icon>
              </v-flex>
              <v-flex xs12>
                <router-link to="/Profile">
                  <span
                    v-if="appLogin"
                    style="
                      font-family: poppinsmedium;
                      font-size: 13px;
                      color: #1e1b1b;
                    "
                  >
                    {{ appUser.contactPerson }}&nbsp;
                    <!-- {{ appUser.lastname }} -->
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 pt-4>
                <v-btn
                  v-if="!appLogin"
                  color="#0000001f"
                  outlined
                  @click="userRegister"
                  tile
                  small
                  :ripple="false"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 14px;
                      color: #ff0000;
                    "
                  >
                    LOGIN/SIGNUP
                  </span>
                </v-btn>
                <v-btn
                  v-if="appLogin"
                  color="#0000001f"
                  outlined
                  tile
                  small
                  :ripple="false"
                  @click="appLogout"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 14px;
                      color: #ff0000;
                    "
                  >
                    LOGOUT
                  </span>
                </v-btn>
              </v-flex>
              <v-flex xs12 py-2>
                <v-layout wrap justify-center>
                  <v-flex xs12 pt-2>
                    <router-link to="/Orders">
                      <span
                        style="
                          font-family: poppinsregular;
                          font-size: 13px;
                          color: #717171;
                        "
                      >
                        Orders
                      </span>
                    </router-link>
                  </v-flex>
                  <v-flex xs12>
                    <router-link to="/Wishlist">
                      <span
                        style="
                          font-family: poppinsregular;
                          font-size: 13px;
                          color: #717171;
                        "
                      >
                        Wishlist
                      </span>
                    </router-link>
                  </v-flex>
                  <v-flex xs12>
                    <router-link to="/Profile/SavedAddress">
                      <span
                        style="
                          font-family: poppinsregular;
                          font-size: 13px;
                          color: #717171;
                        "
                      >
                        Saved Address
                      </span>
                    </router-link>
                  </v-flex>
                  <!-- <v-flex xs12>
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 13px;
                        color: #717171;
                      "
                    >
                      Coupons
                    </span>
                  </v-flex> -->
                </v-layout>
              </v-flex>
              <v-flex xs10 py-4 v-if="!appLogin">
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 v-if="!appLogin">
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 13px;
                        color: #717171;
                      "
                    >
                      Get access to Agogo Bussines account
                    </span>
                  </v-flex>
                  <v-flex xs12 py-2 pb-6>
                    <v-btn
                      color="#0000001f"
                      outlined
                      tile
                      small
                      :ripple="false"
                      @click="sellerRegister"
                    >
                      <span
                        style="
                          font-family: poppinssemibold;
                          font-size: 14px;
                          color: #ff0000;
                        "
                      >
                        LOGIN/SIGNUP
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-menu>
      </v-flex>
      <v-flex xs4 sm4 md4 lg4 xl4 v-if="appType == 'Client'">
        <router-link to="/Wishlist">
          <v-layout wrap justify-center>
            <v-flex xs12>
              <v-badge
                color="#FF0000"
                :content="appWishlist ? appWishlist : '0'"
                right
                small
                offset-y="15px"
              >
                <v-icon color="#878787" size="25">mdi-bookmark-outline</v-icon>
              </v-badge>
            </v-flex>
            <v-flex xs12 style="line-height: 0.5" pt-1>
              <span
                style="
                  font-family: poppinsregular;
                  font-size: 12px;
                  color: #878787;
                "
              >
                Wishlist
              </span>
            </v-flex>
          </v-layout>
        </router-link>
      </v-flex>
      <v-flex xs4 sm4 md4 lg4 xl4 v-if="appType == 'Client'">
        <router-link to="/Cart">
          <v-layout wrap justify-center>
            <v-flex xs12>
              <v-badge
                color="#FF0000"
                :content="appCart ? appCart : '0'"
                right
                small
                offset-y="15px"
              >
                <v-icon color="#878787" size="25">mdi-cart-outline</v-icon>
              </v-badge>
            </v-flex>
            <v-flex xs12 style="line-height: 0.5" pt-1>
              <span
                style="
                  font-family: poppinsregular;
                  font-size: 12px;
                  color: #878787;
                "
              >
                Cart
              </span>
            </v-flex>
          </v-layout>
        </router-link>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {},
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appCart() {
      if (this.$store.state.cartItems == undefined) {
        return 0;
      } else {
        return this.$store.state.cartItems;
      }
    },
    appWishlist() {
      if (this.$store.state.wishlistItems == undefined) {
        return 0;
      } else {
        return this.$store.state.wishlistItems;
      }
    },
    appUser() {
      return this.$store.state.userData;
    },
    appType() {
      return this.$store.state.userType;
      // return this.$store.state.userType;
    },
  },

  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
    sellerRegister() {
      localStorage.setItem("regType", "Seller");
      this.$router.push("/Login");
    },
    userRegister() {
      localStorage.setItem("regType", "Client");
      this.$router.push("/Login");
    },
  },
};
</script>